// ---------------------------------------------------------------------------
// Socket.IO namespaces
// ---------------------------------------------------------------------------
export const SOCKET_NAMESPACES = {
    /**
     * Kiosk display + kiosk agent. Auth: { kioskKey, client: 'display' | 'agent' }.
     * Owners can also watch a kiosk's screen read-only with { previewToken, client: 'preview' }.
     */
    kiosk: '/kiosk',
    /** Owner dashboard. Auth: { token } (JWT from /api/auth/login). */
    owner: '/owner',
    /** Customer phone. Auth: { token, clientSecret } from the session claim. */
    customer: '/customer',
};
/**
 * Connect error sent when a kiosk already has an agent connected. Only one agent may run per
 * kiosk: print jobs go to every agent socket, so two agents would print each job twice.
 */
export const AGENT_ALREADY_CONNECTED = 'Another kiosk agent is already connected for this kiosk';
/** Connect error for a kiosk key the server doesn't know: rotated, re-paired elsewhere, or the kiosk was deleted. */
export const INVALID_KIOSK_KEY = 'Invalid kiosk key';
export const PRINTER_DRIVER_KINDS = ['cups', 'windows', 'mock'];
/**
 * True when the agent runs as another account than the one signed in at the PC's screen (both must be known).
 * Lenient on purpose, so it never reports a mismatch that isn't there: case is ignored, and the same user name with a
 * different domain part counts as the same account.
 */
export function accountsDiffer(agentUser, consoleUser) {
    const a = agentUser?.trim().toLowerCase();
    const c = consoleUser?.trim().toLowerCase();
    if (!a || !c || a === c)
        return false;
    const name = (u) => u.slice(u.lastIndexOf('\\') + 1);
    return name(a) !== name(c);
}
//# sourceMappingURL=protocol.js.map